import React from 'react';

import { ConsumptionPageTypes } from 'src/types/consumption';

import * as customStyled from './styles';

interface TitleProps extends ConsumptionPageTypes.CommonUIProps {
  titleDetails: TitleItem[];
  spaceY: string;
  fontSize?: number;
  fontWeight?: number;
}

export interface TitleItem {
  text: string;
  link?: string;
}

const Title = ({ titleDetails, fontSize, fontWeight, spaceY }: TitleProps) => {
  const navigationHandler = (link: string) => {
    if (link) {
      window.location.href = link;
    }
  };
  return (
    <div css={customStyled.titleWrapper}>
      <h1
        data-testid="metadata-title"
        css={[
          customStyled.dynamicStyles(fontSize, fontWeight, spaceY as string)
        ]}>
        {titleDetails.map((titleItem: TitleItem, index: number) => {
          const { text, link } = titleItem;
          return (
            <React.Fragment key={index}>
              {link ? (
                <a
                  data-testid="title-link"
                  href={link}
                  onClick={() => navigationHandler(link)}>
                  {text}
                </a>
              ) : (
                text
              )}
            </React.Fragment>
          );
        })}
      </h1>
    </div>
  );
};

export default React.memo(Title, arePropsEqual);

function arePropsEqual(oldProps: TitleProps, newProps: TitleProps) {
  return (
    oldProps.titleDetails.length === newProps.titleDetails.length &&
    oldProps.titleDetails.every((oldProp, index) => {
      const newPoint = newProps.titleDetails[index];
      return oldProp.link === newPoint.link && oldProp.text === newPoint.text;
    })
  );
}
